export class BooleanValueConverter {
	toView(value: any) {
		return Boolean(value);
	}
}